<template>
  <el-dialog
          :close-on-click-modal="false"
          :visible.sync="isVisible"
          title="科技成果"
  >
    <el-form
            ref="form"
            :model="form"
            label-position="top"
    >

      <el-row :gutter="15">
        <el-col :span="20">
          <el-form-item label="名称">
            <el-input
                    v-model="form.name"
                    autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="年份">
            <el-select
                    v-model="form.year"
                    style="width: 100%"
            >
              <el-option
                      v-for="year in years"
                      :key="year"
                      :label="year"
                      :value="year">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="研究方向">
            <el-input
                    v-model="form.field"
                    autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="院系">
            <el-select
                    v-model="form.college"
                    clearable
                    placeholder="请选择院系"
                    style="width: 100%"
            >
              <el-option
                      v-for="college in colleges"
                      :key="college"
                      :label="college"
                      :value="college">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="负责人">
            <el-input
                    v-model="form.director"
                    autocomplete="off"
                    style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人职称">
            <el-select
                    v-model="form.director_title"
                    placeholder="请选择负责人职称"
                    style="width: 100%"
            >
              <el-option
                      v-for="title in titles"
                      :key="title"
                      :label="title"
                      :value="title">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="应用行业">
        <el-checkbox-group v-model="form.industries" style="border-bottom:1px solid #eee;">
          <el-checkbox label="通信"></el-checkbox>
          <el-checkbox label="电子"></el-checkbox>
          <el-checkbox label="计算机及信息技术"></el-checkbox>
          <el-checkbox label="机械、电子一体化"></el-checkbox>
          <el-checkbox label="新材料"></el-checkbox>
          <el-checkbox label="生物技术"></el-checkbox>
          <el-checkbox label="新能源与节能"></el-checkbox>
          <el-checkbox label="资源环保"></el-checkbox>
          <el-checkbox label="自动化"></el-checkbox>
          <el-checkbox label="集成电路"></el-checkbox>
          <el-checkbox label="交通运输"></el-checkbox>
          <el-checkbox label="仪器仪表"></el-checkbox>
          <el-checkbox label="其他"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="知识产品和获奖情况">
        <el-input
                v-model="form.credit"
                autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="成果简介">
        <ox-editor
                v-model="form.brief"
                category-id="61b1bb69ea9d7441572d124e"
        />
      </el-form-item>
      <el-form-item label="成果形式" style="border-bottom:1px solid #eee;">
        <el-checkbox-group v-model="form.forms">
          <el-checkbox label="样品"></el-checkbox>
          <el-checkbox label="仿真系统"></el-checkbox>
          <el-checkbox label="软件"></el-checkbox>
          <el-checkbox label="论文"></el-checkbox>
          <el-checkbox label="专利"></el-checkbox>
          <el-checkbox label="研究报告、可行性分析报告"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="所处阶段" style="border-bottom:1px solid #eee;">
        <el-checkbox-group v-model="form.stages">
          <el-checkbox label="实验室"></el-checkbox>
          <el-checkbox label="小试"></el-checkbox>
          <el-checkbox label="中试"></el-checkbox>
          <el-checkbox label="样品样机（产品）"></el-checkbox>
          <el-checkbox label="产业化"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="合作意向">
        <el-checkbox-group v-model="form.cooperation_intentions">
          <el-checkbox label="技术转让"></el-checkbox>
          <el-checkbox label="技术许可"></el-checkbox>
          <el-checkbox label="合作研发"></el-checkbox>
          <el-checkbox label="技术融资"></el-checkbox>
          <el-checkbox label="作价入股"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div
            slot="footer"
            class="dialog-footer"
    >
      <el-button
              round
              @click="hide"
      >取 消
      </el-button>
      <el-button
              :loading="isProcessing"
              round
              type="primary"
              @click="save"
      >确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
    import OxEditor from '../../ox/components/form/OxEditor'

    export default {
        name: 'AchievementFormDialog',
        components: {
            OxEditor
        },
        data: function () {
            return {
                years:[
                  2019,
                  2021
                ],
                colleges: [
                    '信息与通信工程学院',
                    '电子科学与工程学院（示范性微电子学院）',
                    '材料与能源学院',
                    '机械与电气工程学院',
                    '光电科学与工程学院',
                    '自动化工程学院',
                    '资源与环境学院',
                    '计算机科学与工程学院（网络空间安全学院）',
                    '信息与软件工程学院（示范性软件学院）',
                    '数学科学学院',
                    '物理学院',
                    '生命科学与技术学院',
                    '基础与前沿研究院',
                    '通信抗干扰技术国家级重点实验室',
                    '航空航天学院',
                    '经济与管理学院'
                ],
                titles: [
                    '教授（博导）',
                    '教授',
                    '副教授',
                    '副教授（博导）',
                    '博士后',
                    '教授级高工',
                    '工程师',
                    '助理工程师',
                    '研究员',
                    '助理研究员',
                    '副研究员',
                    '实验员',
                    '讲师'
                ],
                isProcessing: false,
                isVisible: false,
                form: {
                    id: null,
                    name: null,
                    director: null,
                    college: null,
                    year: 2019,
                    director_title: '教授',
                    field: null,
                    credit: null,
                    brief: null,
                    industries: [],
                    forms: [],
                    stages: [],
                    cooperation_intentions: [],

                }
            }
        },
        methods: {
            reset () {
                this.form = {
                    id: null,
                    name: null,
                    director: null,
                    college: null,
                    director_title: '教授',
                    field: null,
                    year: 2019,
                    credit: null,
                    brief: null,
                    industries: [],
                    forms: [],
                    stages: [],
                    cooperation_intentions: [],
                }
            },
            show (data = null) {
                if (data) {
                    this.form = {
                        id: data.id,
                        name: data.name,
                        year: data.year,
                        director: data.director,
                        college: data.college,
                        director_title: data.director_title,
                        field: data.field,
                        credit: data.credit,
                        brief: data.brief,
                        industries: data.industries,
                        forms: data.forms,
                        stages: data.stages,
                        cooperation_intentions: data.cooperation_intentions
                    }
                } else {
                    this.reset()
                }
                this.isVisible = true
            },
            hide () {
                this.isVisible = false
            },
            save () {
                this.isProcessing = true
                this.$ox
                    .service('achievement')
                    .save(this.form)
                    .then(res => {
                        this.$notify.success({
                            title: '操作成功',
                            message: `科技成果“${this.form.name}”已保存`
                        })
                        this.hide()
                        this.$refs.form.resetFields()
                        this.$refs.form.clearValidate()
                        this.$emit('success', res)
                    })
                    .catch(err => {
                        this.$emit('error', err)
                        this.$notify.error({
                            title: '操作失败',
                            message: '科技成果保存失败，请与系统维护人员联系'
                        })
                    })
                    .finally(() => {
                        this.isProcessing = false
                    })
            }
        }
    }
</script>

<style scoped>
</style>